import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sanity = defineConnector({
  identifier: "sanity",
  name: "Sanity",
  tagLine: "Headless CMS and content platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () =>
    "https://.*\\.api\\.sanity\\.io/.*|https://api\\.sanity\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [sanity.io/manage](https://www.sanity.io/manage), open your project’s **API › Tokens** and add a token.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          placeholder: "sk...",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sanity.io/v2021-06-07/projects",
  },
});
